import { styled } from '@mui/system'
import logo from 'images/farmtrx-logo.png'
import { Box, Button, Checkbox, Grid, FormControlLabel } from '@mui/material'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useState } from 'react'
import EUSAScreen from 'components/eusa-screen'
import { eusaAccepted } from 'actions/user'
import { editUserAccount } from 'api/user'
import { closeModal, shouldShowDashboard } from 'actions/app'

const welcomeScreenImg = `${WIZARD_ASSETS_BASE_URL}/welcome-screen-harvester.png`

export default function AcceptEUSAScreen() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [acceptedEusa, setAcceptEusa] = useState(false)
  //const [readEusa, setReadEusa] = useState(false);
  const dispatch = useDispatch()
  const userData = useSelector((state) => state.account.user)
  const permissions = useSelector((state) => state.account.permissions)
  const onboardingTenantCreated = useSelector(
    (state) => state.app.onboardingTenantCreated,
  )
  const [showPermissions, setShowPermissions] = useState({})
  const alreadyAcceptedEusa = !!userData?.eusaDate

  useEffect(() => {
    setShowPermissions({
      skipWizard: permissions.includes('tenant:list'),
    })
  }, [permissions])

  useEffect(() => {
    if (alreadyAcceptedEusa) {
      setAcceptEusa(true)
    }
  }, [alreadyAcceptedEusa])

  const acceptEusa = (event) => {
    setAcceptEusa(event.target.checked)
  }

  const handleSkipWizard = () => {
    dispatch(closeModal())

    dispatch(shouldShowDashboard())
    localStorage.setItem('wizardActiveStep', 'null')
  }

  const farmId = useSelector((state) => state.farm.singleton?.id)

  const navigateToRegWizardStepper = useCallback(() => {
    if (!alreadyAcceptedEusa) {
      const date = Date.now()
      if (userData?.id) {
        userData.eusaDate = date
        dispatch(editUserAccount(userData))
      } else {
        dispatch(eusaAccepted(date))
      }
    }
    navigate(farmId ? '/wizardStepper' : '/welcomeScreen')
  }, [alreadyAcceptedEusa, userData, farmId])

  useEffect(() => {
    if (onboardingTenantCreated && farmId && userData?.eusaDate) {
      navigate('/wizardStepper')
    }
  }, [farmId, userData, onboardingTenantCreated])

  /*const handleScroll = useCallback((e) => {
    const bottom =
      Math.floor(e.target.scrollHeight - e.target.scrollTop) <=
      e.target.clientHeight;
    if (bottom) {
      setReadEusa(true);
    }
  });*/

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid size={{ sm: 7, md: 6, lg: 6 }}>
          <Box
            sx={{
              mx: 2,
              my: 2,
            }}
          >
            <Box
              sx={{
                mx: 10,
                my: 6,
              }}
            >
              <img width="180" height="30" src={logo} />
            </Box>
            <Box
              sx={{
                mx: 3,
                my: 2,
              }}
            >
              <Grid container spacing={2}>
                <EUSAScreen />
                <Grid size={12}>
                  <Box>
                    <FormControlLabel
                      sx={{ width: '100%' }}
                      control={
                        <Checkbox
                          onChange={acceptEusa}
                          checked={acceptedEusa}
                        />
                      }
                      label={t('read_and_accept')}
                    />
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={!acceptedEusa}
                        sx={{ borderRadius: '25px' }}
                        fullWidth
                        onClick={navigateToRegWizardStepper}
                      >
                        {alreadyAcceptedEusa ? t('next') : t('continue_setup')}
                      </Button>
                      {showPermissions.skipWizard ? (
                        <Button color="primary" onClick={handleSkipWizard}>
                          {t('skip')}
                        </Button>
                      ) : null}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid size={{ sm: 5, md: 6, lg: 6 }}>
          <Box>
            <StyledImg src={welcomeScreenImg} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

const StyledImg = styled('img')({
  width: '49vw',
  height: '99vh',
})
